import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SelectListModule} from '../select-list';
import {DropdownSelectComponent} from './dropdown-select.component';
import { DirectivesModule } from '../directives/directives.module';
import { DropdownMultilevelModule } from 'lib/dropdown-multilevel';
import { MaterialModule } from '../../src/app/material/material.module';

@NgModule({
  imports: [
    CommonModule,
    SelectListModule,
    DirectivesModule,
    DropdownMultilevelModule,
    MaterialModule,
  ],
  declarations: [
    DropdownSelectComponent,
  ],
  exports: [
    DropdownSelectComponent,
  ],
  providers: []
})
export class DropdownSelectModule {}
